import styled from 'styled-components';

export const ContentWrapper = styled.div`
  margin-bottom: ${({ hasMarginBottom }) => (hasMarginBottom && '30px') || 'inherit'};
  margin-top: ${({ hasMarginTop }) => (hasMarginTop && '30px') || 'inherit'};
`;
